import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
gsap.registerPlugin( ScrollTrigger, CustomEase );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
    },
    animate: function() {
      if ( !window.hasMotion ) return;

      function createAnimation( elements, startAnimationObj, animationFunction, start = 'top 90%' ) {
        if ( ( typeof elements === 'string' && document.querySelectorAll( elements ).length > 0 ) || ( typeof elements === 'object' && elements.length > 0 ) ) {
          gsap.set( elements, startAnimationObj );

          const triggers = ScrollTrigger.batch( elements, {
            toggleClass: 'js-animated',
            once: true,
            start: start,
            onEnter: ( batch ) => {
              animationFunction( batch );
            },
          } );

          ScrollTrigger.addEventListener( 'refreshInit', () => {
            triggers.forEach( ( trigger ) => {
              if ( trigger.progress > 0 ) {
                animationFunction( trigger.trigger );
              }
            } );
          } );
        }
      }

      // global animations in animate will load in after running common.js init function, all component javascript, and before common.js finalize function.
      // This should improve animations loading in and fix odd start times due to load order
      /*
       * Fade on scroll
       */
      const fadeUpClasses = '.js-fade--up:not(.js-ignore)';
      function fadeUpTimeline( elements ) {
        const tl = gsap.timeline();
        /*
          * The following .to functions are the equivalent of
          * transition: opacity 0.35s ease 0.1s, transform 1s ease-out 0.1s;
          */

        /* Opacity style and transitions */
        tl.to( elements, {
          opacity: 1, // property/value
          duration: 0.35, // duration e.g. 0.35s
          ease: '0.25,0.1,0.25,1', // timing function e.g. ease
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );

        /* Transform style and transitions */
        tl.to( elements, {
          y: 0, // property/value
          duration: 1, // duration e.g. 1s
          ease: '0, 0, 0.58, 1.0', // timing function eg. ease-out
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );
      }
      createAnimation( fadeUpClasses, {opacity: 0, y: 25}, fadeUpTimeline );

      /*
       * Fade on scroll
       */
      const fadeDownClasses = '.js-fade:not(.js-ignore), .js-fade--down:not(.js-ignore)';
      function fadeDownTimeline( elements ) {
        const tl = gsap.timeline();
        /*
          * The following .to functions are the equivalent of
          * transition: opacity 0.35s ease 0.1s, transform 1s ease-out 0.1s;
          */

        /* Opacity style and transitions */
        tl.to( elements, {
          opacity: 1, // property/value
          duration: 0.35, // duration e.g. 0.35s
          ease: '0.25,0.1,0.25,1', // timing function e.g. ease
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );

        /* Transform style and transitions */
        tl.to( elements, {
          y: 0, // property/value
          duration: 1, // duration e.g. 1s
          ease: '0, 0, 0.58, 1.0', // timing function eg. ease-out
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );
      }
      createAnimation( fadeDownClasses, {opacity: 0, y: -25}, fadeDownTimeline );

      /*
       * Fade on scroll
       */
      const fadeLeftClasses = '.js-fade-left:not(.js-ignore)';
      function fadeLeftTimeline( elements ) {
        const tl = gsap.timeline();
        /*
          * The following .to functions are the equivalent of
          * transition: opacity 0.35s ease 0.1s, transform 1s ease-out 0.1s;
          */

        /* Opacity style and transitions */
        tl.to( elements, {
          opacity: 1, // property/value
          duration: 0.35, // duration e.g. 0.35s
          ease: '0.25,0.1,0.25,1', // timing function e.g. ease
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );

        /* Transform style and transitions */
        tl.to( elements, {
          x: 0, // property/value
          duration: 1, // duration e.g. 1s
          ease: '0, 0, 0.58, 1.0', // timing function eg. ease-out
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );
      }
      createAnimation( fadeLeftClasses, {opacity: 0, x: 25}, fadeLeftTimeline );

      const fadeRightClasses = '.js-fade-right:not(.js-ignore)';
      function fadeRightTimeline( elements ) {
        const tl = gsap.timeline();
        /*
          * The following .to functions are the equivalent of
          * transition: opacity 0.35s ease 0.1s, transform 1s ease-out 0.1s;
          */

        /* Opacity style and transitions */
        tl.to( elements, {
          opacity: 1, // property/value
          duration: 0.35, // duration e.g. 0.35s
          ease: '0.25,0.1,0.25,1', // timing function e.g. ease
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );

        /* Transform style and transitions */
        tl.to( elements, {
          x: 0, // property/value
          duration: 1, // duration e.g. 1s
          ease: '0, 0, 0.58, 1.0', // timing function eg. ease-out
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );
      }
      createAnimation( fadeRightClasses, {opacity: 0, x: -25}, fadeRightTimeline );


      /*
       * Fade group
       */
      const fadeDownGroupClasses = '.js-fade-group--down, .js-fade-group';
      $( fadeDownGroupClasses ).each( function() {
        gsap.set( $( this ).find( '> *:not(.js-ignore)' ), {opacity: 0, y: -25} );
        ScrollTrigger.batch( $( this ).find( '> *:not(.js-ignore)' ), {
          onEnter: ( elements, triggers ) => {
            gsap.to( elements, {opacity: 1, stagger: 0.25, ease: '0.25,0.1,0.25,1'} );
          },
        } );

        ScrollTrigger.batch( $( this ).find( '> *:not(.js-ignore)' ), {
          onEnter: ( elements, triggers ) => {
            gsap.to( elements, {y: 0, stagger: 0.25, ease: '0, 0, 0.58, 1.0'} );
          },
        } );
      } );

      const fadeUpGroupClasses = '.js-fade-group--up';
      $( fadeUpGroupClasses ).each( function() {
        gsap.set( $( this ).find( '> *:not(.js-ignore)' ), {opacity: 0, y: 25} );
        ScrollTrigger.batch( $( this ).find( '> *:not(.js-ignore)' ), {
          onEnter: ( elements, triggers ) => {
            gsap.to( elements, {opacity: 1, stagger: 0.25, ease: '0.25,0.1,0.25,1'} );
          },
        } );

        ScrollTrigger.batch( $( this ).find( '> *:not(.js-ignore)' ), {
          onEnter: ( elements, triggers ) => {
            gsap.to( elements, {y: 0, stagger: 0.25, ease: '0, 0, 0.58, 1.0'} );
          },
        } );
      } );

      /*
       * Reveal on scroll
       */
      function reveal( elements ) {
        gsap.to( elements,
            {
              clipPath: 'inset(0% 0% 0% 0%)',
              duration: 1.15,
              ease: '.17,.67,.57,.97',
              stagger: 0.2, // delay e.g 0.2s
            },
        );
      }

      const revealRightClasses = '.js-reveal-right:not(.js-ignore)';
      createAnimation( revealRightClasses, {clipPath: 'inset(0 100% 0 0)'}, reveal );

      const revealLeftClasses = '.js-reveal-left:not(.js-ignore)';
      createAnimation( revealLeftClasses, {clipPath: 'inset(0 0 0 100%)'}, reveal );

      const revealDownClasses = '.js-reveal-down:not(.js-ignore)';
      createAnimation( revealDownClasses, {clipPath: 'inset(0 0 100% 0)'}, reveal );

      const revealUpClasses = '.js-reveal-up:not(.js-ignore)';
      createAnimation( revealUpClasses, {clipPath: 'inset(100% 0 0 0)'}, reveal );

      /*
       * Fit Image Load Up
       */
      const fitImageLoadUpClasses = '.js-fit-image-load-up img';
      function fitImageLoadUpTimeline( elements ) {
        const tl = gsap.timeline();
        /*
          * The following .to functions are the equivalent of
          * transition: opacity 0.35s ease 0.1s, transform 1s ease-out 0.1s;
          */

        // /* Opacity style and transitions */
        // tl.to( elements, {
        //   opacity: 1, // property/value
        //   duration: 0.35, // duration e.g. 0.35s
        //   ease: '0.25,0.1,0.25,1', // timing function e.g. ease
        //   stagger: 0.1, // delay e.g 0.1s
        // }, 0 );

        /* Transform style and transitions */
        tl.to( elements, {
          y: 0, // property/value
          scale: 1.1,
          duration: 1, // duration e.g. 1s
          ease: '0, 0, 0.58, 1.0', // timing function eg. ease-out
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );
      }
      createAnimation( fitImageLoadUpClasses, {y: 15, scale: 1.1}, fitImageLoadUpTimeline );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
